import React,{useMemo, useState} from "react";
import { PageDialogContent, PageDialogFooter } from "../../components/dialog";
import { BtnComponent } from "../../components/button";
import ConvertStringToHtml from "../../components/ConvertStringToHtml";
import { chatApi } from "../../services/chatService";
import { imageFromUuid } from "../../helpers/utility";
import { useGroupChatContext } from "../../context/groupchatContext";
import { printe10xEncounterSummary } from "../../services/login";

const EncounterPreview = (({encounterData, closeHandler}) =>{
    
    const [printEncounterSummary] = chatApi.endpoints.printEncounterSummary.useLazyQuery();
    const [isLoading, setIsLoading] = useState(false);
    const groupChatContext = useGroupChatContext();
    const {authData} = useMemo(() => ({
        authData: groupChatContext.authData,
    }));

    const printEncounter = async() => {
        try {
            let token = '&na_auth='+ authData.auth
            setIsLoading(true);
            const response = await printe10xEncounterSummary({ encounter_id: encounterData.encounter,  token});
            
            if (response.data?.response?.data) {
                let url = imageFromUuid(response.data?.response?.data.pdf.uuid);
                window.open(url, "_blank");
            }
        } catch (error) {
            console.error("Error fetching encounter summary:", error);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            <PageDialogContent contentCls="overflow-y-auto">
                <div className="text-left">
                    {encounterData.sign == 1 ?
                        <ConvertStringToHtml msg={encounterData.signed_note} />
                        :
                        <>
                            {encounterData.preview_segments.map((segment, index)=>{
                                return(
                                    <ConvertStringToHtml key={index} msg={segment.html} />
                                )
                            })}
                        </>
                    }
                </div>
            </PageDialogContent>

            <PageDialogFooter className="sticky bottom-0">
                <div className="flex justify-end gap-x-2">
                    <BtnComponent loading={isLoading} text="Print" onClick={printEncounter} />
                    <BtnComponent text="Close" btnType="default" onClick={closeHandler} />
                </div>
            </PageDialogFooter>
        </>
    );
})

export default EncounterPreview;
